import MarginCalcRepository from "@adapters/features/Tools/MarginCalculator/Repository/MarginCalculator";
import OptionRepository from "@adapters/features/Markets/Options/Repository/Options";
export default (http) => {
    return {
        marginCalculator: new MarginCalcRepository(http),
        expiryDates: new OptionRepository(http),
    };
};
